<template>
  <div id="howtosolve">
        <section class="py-5">
            <div class="container px-4 px-lg-5 my-5">
                <div class="row gx-4 gx-lg-5 text-start">
                    <h2>How to Solve</h2>
                    <p>Your objective is to fit the provided puzzle pieces into the corresponding 4x4 quadrants, so that when correctly placed, they reveal a story, passage, or interesting fact. When finished, the puzzle will read from left to right, on successive lines. Each puzzle piece is used only once.</p>
                    <p>A black square indicates the end of a word. Words don't necessarily end at the end of a line; they can wrap around to the next line.</p>
                    <p class="text-center"><img src="/images/example.png" class="img-fluid" /></p>
                </div>
            </div>
        </section>
  </div>
</template>

<script>

export default {
  name: 'HowToSolve',
  mounted() {
    document.title = "Katie's Puzzles | How to Solve";
  }
}
</script>

<style>

</style>
